/**
 * 门户返回默认配置数据
 */
export const home = [
  {
    borderRadius: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    legendPaddingTypeFlag: 1,
    legendPadding: 10,
    legendPaddingTop: 10,
    legendPaddingRight: 10,
    legendPaddingBottom: 10,
    legendPaddingLeft: 28
  },
  {
    styleId: 2,
    borderRadius: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    legendPaddingTypeFlag: 1,
    legendPadding: 10,
    legendPaddingTop: 10,
    legendPaddingRight: 10,
    legendPaddingBottom: 10,
    legendPaddingLeft: 28,
    titlePaddingTypeFlag: 2,
    titlePaddingRight: 10,
    titlePaddingLeft: 10,
    datePaddingBottomVal: 10,
    activityColorIsThemeColor: false,
    activityColor: "#F6AE54",
    activeColor: "#fff",
    showActiveBorder: false,
    activeBgColorIsThemeColor: true,
    titleBgColorIsThemeColor: false,
    titleBgColor: "transparent",
    bgColor: "#1C274D",
    weekBgColor: "transparent",
    weekColor: "rgba(255,255,255,1)",
    color: "rgba(255,255,255,1)",
    todayLegendColor: "rgba(255,255,255,1)",
    activityLegendColor: "rgba(255,255,255,1)",
    todayStyleColor: "rgba(255,255,255,1)",
    notCurrentTextColor: "rgba(255, 255, 255, 0.5)",
    hoverColor: "rgba(255,255,255,1)",
    hoverBgColor: "rgba(51, 57, 93, 1)",
    activityBgColorIsThemeColor: false,
    activityBgColor: "rgba(246, 174, 84, 1)",
    activityWidth: 20,
    activityBorderRadius: 10,
    selectlistsHeight: 200,
    selectOptionsHeight: 34,
    titleBorderRadius: 0,
    titlePadding2: 0,
    titlePaddingTop2: 0,
    titlePaddingRight2: 0,
    titlePaddingLeft2: 0,
    titlePaddingBottom2: 0,
    tooltipBorderRadius: 6,
    tooltipBorderTopLeftRadius: 6,
    tooltipBorderTopRightRadius: 6,
    tooltipBorderBottomRightRadius: 6,
    tooltipBorderBottomLeftRadius: 6,
    tooltipBorderWidth: 0,
    tooltipBorderStyle: "solid",
    tooltipBorderIsThemeColor: false,
    tooltipBorderColor: "transparent",
    tooltipBorderTypeFlag: 1,
    activityTooltipWidth: 200,
    activityTooltipHeight: 100,
    activityLineHeight: 30,
    activityTooltipBgColor: "rgba(51, 57, 93, 1)",
    tooltipPaddingTypeFlag: 1,
    tooltipPaddingTop: 12,
    tooltipPaddingRight: 16,
    tooltipPaddingBottom: 12,
    tooltipPaddingLeft: 16,
    titleBorderWidth: 0,
    titleBorderTopLeftRadius: 0,
    titleBorderTopRightRadius: 0,
    titleBorderBottomRightRadius: 0,
    titleBorderBottomLeftRadius: 0,
    titleSelectFontSize: 12,
    titleSelectFontFamily: "sans-serif",
    titleTextAlign: "left"
  },
  {
    styleId: 3,
    borderRadius: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    legendPaddingTypeFlag: 1,
    legendPadding: 10,
    legendPaddingTop: 10,
    legendPaddingRight: 10,
    legendPaddingBottom: 10,
    legendPaddingLeft: 28,
    columnMargin: 0,
    showDayBorder: false,
    dayBorderColor: "rgba(255,255,255,0)",
    dayBorderIsThemeColor: false,
    dayBgColor: "rgba(255,255,255,0)",
    dayBgColorIsThemeColor: false,
    dayBorderTypeFlag: 2,
    dayBorderRadius: 0,
    dayBorderTopLeftRadius: 0,
    dayBorderTopRightRadius: 0,
    dayBorderBottomRightRadius: 0,
    dayBorderBottomLeftRadius: 0,
    todayLunarType: 1,
    selfLunarTxt: "",
    todayLunarStyleColor: "#B3B3B3",
    todayLunarStyleFontFamily: "sans-serif",
    todayLunarStyleFontSize: 12,
    todayLunarStyleFontWeight: 400,
    activityLeft: 0,
    activityRight: 0,
    activityTop: 0,
    activityBottom: 0,
    activityLocation3: "bottom",
    firstDayOfWeek: 7
  },
]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{}]

/**
 * app返回默认配置数据
 */
export const appHome = [
  {
    width: 374
  },
  {
    styleId: 3,
    width: 374,
    borderRadius: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    legendPaddingTypeFlag: 1,
    legendPadding: 10,
    legendPaddingTop: 10,
    legendPaddingRight: 10,
    legendPaddingBottom: 10,
    legendPaddingLeft: 28,
    columnMargin: 0,
    showDayBorder: false,
    dayBorderColor: "rgba(255,255,255,0)",
    dayBorderIsThemeColor: false,
    dayBgColor: "rgba(255,255,255,0)",
    dayBgColorIsThemeColor: false,
    dayBorderTypeFlag: 2,
    dayBorderRadius: 0,
    dayBorderTopLeftRadius: 0,
    dayBorderTopRightRadius: 0,
    dayBorderBottomRightRadius: 0,
    dayBorderBottomLeftRadius: 0,
    todayLunarType: 1,
    selfLunarTxt: "",
    todayLunarStyleColor: "#B3B3B3",
    todayLunarStyleFontFamily: "sans-serif",
    todayLunarStyleFontSize: 12,
    todayLunarStyleFontWeight: 400,
    activityLeft: 0,
    activityRight: 0,
    activityTop: 0,
    activityBottom: 0,
    activityLocation3: "bottom",
    firstDayOfWeek: 7
  },
]
